import { render, staticRenderFns } from "./px_data.vue?vue&type=template&id=1f5f834e"
import script from "./px_data.vue?vue&type=script&lang=js"
export * from "./px_data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports